import { render, staticRenderFns } from "./PLabel.vue?vue&type=template&id=28ff9a96&scoped=true&"
import script from "./PLabel.vue?vue&type=script&lang=ts&"
export * from "./PLabel.vue?vue&type=script&lang=ts&"
import style0 from "./PLabel.vue?vue&type=style&index=0&id=28ff9a96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff9a96",
  null
  
)

export default component.exports